export const getFlowName = (name?: string | null, projectLocalId?: number) =>
  name || `Untitled ${projectLocalId}`
